import style from './../Report.module.scss';
import {FaSitemap} from 'react-icons/fa';
import ErrorsByType from '../ErrorsReport/ErrorsByType/ErrorsByType';
import ErrorsByPlatform from '../ErrorsReport/ErrorsByPlatform/ErrorsByPlatform';
import ErrorsByClinic from '../ErrorsReport/ErrorsByClinic/ErrorsByClinic';
import ReportTypeStructure from '../ReportTypeStructure';
import moment from 'moment';
import TreatmentsByClinic from '../TreatmentsReport/TreatmentsByClinic/TreatmentsByClinic';
import PulsesByHandle from '../TreatmentsReport/PulsesByHandle/PulsesByHandle';
import ClinicsEquipment from './ClinicsEquipment/ClinicsEquipment';
import ClinicsStatsTable from './../DistributorClinicsReport/ClinicsStatsTable/ClinicsStatsTable';
import _ from 'lodash';
import ApplicatorsTable from './../ApplicatorsReport/ApplicatorsTable/ApplicatorsTable';

const DistributorReport = ({report, isStandalone}) => {
    const {data} = report;
    const {distributor, equipment, treatments, errors, clinics, applicators} = data;

    const getHeader = () => {
        return (
            <div className='d-flex'>
                <div>
                    <h1>{distributor.name}: Distributor Report</h1>
                    <label className={style.reportType}>{moment(report.filters.date_range.startDate).format('ll')} - {moment(report.filters.date_range.endDate).format('ll')}</label>
                </div>
            </div>
        )
    }

    const getContent = () => {
        return (
            <>
                <section>
                    <div className={style.cardRow}>
                        <div className={[style.card, style.cardFluid, style.col3].join(' ')}>
                            <h3>{clinics.length}</h3>
                            <label>Total Clinics</label>
                        </div>
                        <div className={[style.card, style.cardFluid, style.col3].join(' ')}>
                            <h3>{_.sumBy(clinics, 'platforms')}</h3>
                            <label>Total Platforms</label>
                        </div>
                        <div className={[style.card, style.cardFluid, style.col3].join(' ')}>
                        <h3>{_.sumBy(clinics, 'applicators')}</h3>
                            <label>Total Applicators</label>
                        </div>
                        <div className={[style.card, style.cardFluid, style.col3].join(' ')}>
                        <h3>{_.sumBy(clinics, 'treatments').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</h3>
                            <label>Total Treatments</label>
                        </div>
                    </div>
                </section>
                <section>
                    <h5>Treatments Overview</h5>
                    <div className={style.cardRow}>
                        <div className={[style.card, style.col6].join(' ')} style={{minHeight: 300}}>
                            <TreatmentsByClinic data={treatments.by_clinic} />
                        </div>
                        <div className={[style.card, style.col6].join(' ')} style={{minHeight: 300}}>
                            <PulsesByHandle data={applicators.map((a) => {
                                return {
                                    pulses: a.pulses,
                                    handle_id: a.id,
                                    handle_name: a.handle_id
                                }
                            })} />
                        </div>
                    </div>
                </section>
                <section>
                    <h5>Errors Overview</h5>

                    <div className={style.cardRow}>
                        <div className={[style.card, style.col6].join(' ')} style={{minHeight: 300}}>
                            <ErrorsByType data={errors.by_type} />
                        </div>
                        <div className={[style.card, style.col6].join(' ')} style={{minHeight: 300}}>
                            <ErrorsByPlatform data={errors.by_platform} />
                        </div>
                        <div className={[style.card, style.col6].join(' ')} style={{minHeight: 300}}>
                            <ErrorsByClinic data={errors.by_clinic} />
                        </div>
                    </div>
                </section>
                <section>
                    <h5>Clinics Overview</h5>
                    <div className={style.cardRow}>
                        <div className={[style.col6].join(' ')} style={{minHeight: 300}}>
                            <ClinicsStatsTable isStandalone={isStandalone} clinics={clinics} />
                        </div>
                    </div>
                </section>
                <section>
                    <h5>Applicators Overview</h5>
                    <div className={style.cardRow}>
                        <div className={[style.col6].join(' ')} style={{minHeight: 300}}>
                            <ApplicatorsTable isStandalone={isStandalone} applicators={applicators} />
                        </div>
                    </div>
                </section>
            </>
        )
    }
    return (
        <ReportTypeStructure isStandalone={isStandalone} report={report} header={getHeader()} content={getContent()} />
    )
}

export default DistributorReport;